import React, { PropTypes } from "react";
import styles from "components/manage-categories/delete-categories-modal.scss";
import { Modal } from "components/common/modal";
import { Button } from "components/common/button";

export const DeleteCategoriesModal = ({
  isDeleteCategoriesLoading,
  isDeleteCategoriesVisible,
  onDeleteCategories,
  onHideDeleteCategories,
  selectedCategoryIds
}) => (
  <Modal
    isVisible={ isDeleteCategoriesVisible }
    onClose={ onHideDeleteCategories }
    transitionName="delete-categories"
  >
    <h2>Permanently delete these categories?</h2>
    <div className={ styles.controls }>
      <Button link onClick={ onHideDeleteCategories }>cancel</Button>
      <Button
        danger
        disabled={ selectedCategoryIds.length === 0 }
        loading={ isDeleteCategoriesLoading }
        onClick={ onDeleteCategories }
      >
        Delete Categories
      </Button>
    </div>
  </Modal>
);

DeleteCategoriesModal.propTypes = {
  isDeleteCategoriesLoading: PropTypes.bool.isRequired,
  isDeleteCategoriesVisible: PropTypes.bool.isRequired,
  onDeleteCategories: PropTypes.func.isRequired,
  onHideDeleteCategories: PropTypes.func.isRequired,
  selectedCategoryIds: PropTypes.arrayOf(PropTypes.string).isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/manage-categories/delete-categories-modal.jsx